import React from 'react'
import PropTypes from 'prop-types'
import sortBy from 'lodash/sortBy'
import { PAGE_CONTEXT as p } from 'Constants'
import { Link } from 'Blocks'
import { GAEvent, path, UrlBuilder } from 'Utils'
import config, { gaSelectors } from 'Config'

const CategoryFilter = props => {
  const {
    items = [],
    attributes = {
      itemType: 'http://schema.org/BreadcrumbList',
      itemScope: ''
    },
    itemAttributes = {
      itemScope: '',
      itemType: 'http://schema.org/ListItem',
      itemProp: 'itemListElement'
    },
    className = '',
    queryString = '',
    gaEventContext = '',
    style = {},
    shouldRender = true,
    categoryId = ''
  } = props
  const orderedItems = sortBy(items, 'name')

  const renderItem = ({ name, slug, uuid, to }) => {
    if (!to) {
      to = path(p.PRODUCT_LIST, { uuid, subCategory: slug })
    }

    if (queryString.length) {
      const urlBuilder = new UrlBuilder(queryString)
      to += urlBuilder.setPage(1).getQueryString()
    }

    return (
      <li key={uuid} {...itemAttributes}>
        <GAEvent
          {...{
            category: gaSelectors.getSubMenuSettings.category.replace(
              '$1',
              gaEventContext
            ),
            action: gaSelectors.getSubMenuSettings.action,
            label: `${name} - ${to}`,
            additionalProps: {
              linkName: name,
              destinationUrl: to,
            },
          }}
        >
          <Link className={uuid === categoryId ? 'active' : ''} {...{ to }}>
            {name}
          </Link>
        </GAEvent>
      </li>
    )
  }

  const heading = config.filters.categoryFilterHeading
  return shouldRender ? (
    <div {...{ className, style }}>
      {heading && items.length > 0 && <h3>{heading}</h3>}
      <ul {...attributes}>{orderedItems.map(renderItem)}</ul>
    </div>
  ) : null
}

CategoryFilter.displayName = 'CategoryFilter'

CategoryFilter.propTypes = {
  attributes: PropTypes.shape({
    itemType: PropTypes.string,
    itemScope: PropTypes.string
  }),
  categoryId: PropTypes.string,
  className: PropTypes.string,
  gaEventContext: PropTypes.string,
  itemAttributes: PropTypes.shape({
    itemScope: PropTypes.string,
    itemType: PropTypes.string,
    itemProp: PropTypes.string
  }),
  items: PropTypes.array,
  queryString: PropTypes.string,
  shouldRender: PropTypes.bool,
  style: PropTypes.object
}

export default CategoryFilter
